
import { Component, Vue } from "vue-property-decorator";

import PagedListBase, {
  PagedRequestDto,
} from "@/lib/view-base/paged-list-base";
import {
  OptionSettingsDto,
  VipPaySettingService,
  Int32EntityDto, TenantVipTypeSetting
} from "@/api/service-proxies";
import Pagination from "@/components/Pagination/index.vue";
import PayRecord from "./components/pay-record.vue";
import EditDialog from "./components/edit-dialog.vue";
import EditRegistrationDialog from "./components/edit-registrationdialog.vue";
import { Row } from "element-ui";
import VipDaysDialog from "../unicomRegistration/components/vipDaysDialog.vue";

//import WangEditor from 'wangeditor'
class PageUserRequest extends PagedRequestDto {
  name!: string;
  isQRCode = false;
}

@Component({
  name: "User",
  components: {
    Pagination,
    PayRecord,
    EditDialog,
    EditRegistrationDialog
  },
})
export default class extends PagedListBase<PageUserRequest, OptionSettingsDto> {
  request = new PageUserRequest();
  payRecordVisible: boolean = false;
  changeVisible: boolean = false;
  settingDiaolg = false;
  currentTenantName = "";
  submitItem = new TenantVipTypeSetting();


  private payService = new VipPaySettingService();

  created() {
    this.refresh();
  }

  getpage(finishCallback: Function): void {
    this.payService
      .getAllSettings(
        this.request.name,
        this.request.isQRCode,
        this.request.sorting,
        this.request.skipCount,
        this.request.maxResultCount
      )
      .then((result) => {
        this.list = result.items;
        this.showPaging(result);
        this.isTableLoading = false;
      });
  }
  //开启/关闭联通
  openUnionButton(id: any) {
    var input = new Int32EntityDto();
    input.id = id;
    this.payService.createUnionRegistration(input).then((result) => {
      this.refresh();
    });
  }
  search() {
    this.refresh();
  }

  handleAddSchoolManager(row: OptionSettingsDto) {
    this.payService
      .getVipPriceSettingByTenantId(row.schoolId, false)
      .then((result) => {
        (this.$refs.edit as EditDialog).open(
          row.schoolId,
          row.schoolName,
          result
        );
        //(this.$refs.editRegistration as EditRegistrationDialog).open(row.schoolId, row.schoolName, result)
      });
  }

  listenEventHide() {
    this.changeVisible = false;
  }

  GetPayChangedRecord(row: OptionSettingsDto) {
    this.payService.getOperateRecords(row.schoolId).then((result) => {
      if (result.length == 0) {
        this.$notify.info("当前学校没有操作记录");
        return;
      }

      (this.$refs.records as PayRecord).open(result);
    });
  }

  handUpdateRole() {
    this.$notify.success("查看记录");
  }

  schoolVipSetting(item) {
    this.currentTenantName = item.schoolName;
    this.getSetting(item.schoolId);
    this.settingDiaolg = true;
  }


  //获取学校设置
  getSetting(schoolId: number) {
    this.payService.getTenantVipTypeSetting(schoolId)
      .then((res) => {
        this.submitItem = res;
      })
      .catch(() => {
        this.$message.error("获取数据失败");
      })
  }

  ///提交会员设置
  sunmitSetting() {
    this.payService.updateTenantVipTypeSetting(this.submitItem)
      .then((res) => {
        this.$message.success("修改成功")

        this.settingDiaolg = false;
      })
      .catch(() => {
        this.$message.error("修改失败");
      })
  }

  vipTypeChange() {
    this.settingDiaolg
  }
}
